import { stationsActions } from '../reducer';

import { StationsState } from '../../types';

export const updateFilteredStations = (stations?: StationsState['filteredStations']['data']) => stationsActions
  .updateFilteredStations(stations);
